import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { ymHit } from '@webapp/common/lib/metrics';

// Шлёт hit при клиентских переходах react-router: при первой загрузке
// страницы хит отправляет сама Метрика из init.
export const MetrikaHits: FC = () => {
    const location = useLocation();
    const prevUrl = useRef<string | null>(null);

    useEffect(() => {
        const url = `${window.location.origin}${location.pathname}${location.search}${location.hash}`;

        if (prevUrl.current && prevUrl.current !== url) {
            ymHit(url, prevUrl.current);
        }

        prevUrl.current = url;
    }, [location]);

    return null;
};
